export default {
  ADD_CATEGORY_TICKET_TITLE_DOSE_NOT_EXIST: "عنوان وارد نشده.",

  ADD_TICKET_TITLE_DOSE_NOT_EXIST: "عنوان وارد نشده.",
  ADD_TICKET_TEXT_DOSE_NOT_EXIST: "متن وارد نشده.",
  ADD_TICKET_CATEGORY_DOSE_NOT_EXIST: "دسته وارد نشده.",
  ADD_TICKET_CATEGORY_INVALID: "دسته نامعتبر است.",

  NAME_NOTIFICATION_DOSENOT_EXIST: "نام موجود نیست.",
  NAME_NOTIFICATION_INVALID: "نام نامعتبر است.",

  MOBILE_NOTIFICATION_DOSENOT_EXIST: "موبایل موجود نیست.",
  MOBILE_NOTIFICATION_INVALID: "موبایل نامعتبر است.",

  TICKET_STATE_PENDING: "در حال انتظار",
  TICKET_STATE_ANSWERED: "پاسخ داده شده",
  TICKET_STATE_CLOSED: "بسته شده",
};
